export default "/images/vendor/flag-icons/flags/4x3/do.svg?786a4971dfcac04b5eee5e49e7e8637c";